module.exports = __webpack_public_path__ + "img/cj_3@2x.7926e579.png";